"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { useId, useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { cn } from "../../../utils";
import type { VariantProps, SvgProps } from "../../color-block.types";
function RectangleLgMobileSvg(t0) {
  const $ = _c(198);
  const {
    color,
    animated,
    shapeScale
  } = t0;
  const id = useId();
  let t1;
  if ($[0] !== animated || $[1] !== shapeScale) {
    t1 = origin => ({
      scale: animated ? shapeScale : 1,
      transformOrigin: origin
    });
    $[0] = animated;
    $[1] = shapeScale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const style = t1;
  switch (color) {
    case "bright-blue":
      {
        const t2 = `${id}-bright-blue`;
        let t3;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="1015" fill="white" />;
          $[3] = t3;
        } else {
          t3 = $[3];
        }
        let t4;
        if ($[4] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[4] = t2;
          $[5] = t4;
        } else {
          t4 = $[5];
        }
        const t5 = `url(#${id}-bright-blue)`;
        let t6;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="1015" fill="#5375CF" />;
          $[6] = t6;
        } else {
          t6 = $[6];
        }
        let t7;
        if ($[7] !== style) {
          t7 = <motion.path opacity={0.7} d="M487 1015H164L164 436.479C164 347.277 236.318 275 325.479 275C414.64 275 487 347.318 487 436.479L487 1015Z" fill="#4668C2" style={style("bottom center")} />;
          $[7] = style;
          $[8] = t7;
        } else {
          t7 = $[8];
        }
        let t8;
        if ($[9] !== style) {
          t8 = <motion.path d="M2 -2.42484e-06L325 -3.05176e-05L325 161.521C325 250.723 252.682 323 163.521 323C74.36 323 2.00002 250.682 2.00002 161.521L2 -2.42484e-06Z" fill="#4668C2" style={style("top center")} />;
          $[9] = style;
          $[10] = t8;
        } else {
          t8 = $[10];
        }
        let t9;
        if ($[11] !== t5 || $[12] !== t7 || $[13] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[11] = t5;
          $[12] = t7;
          $[13] = t8;
          $[14] = t9;
        } else {
          t9 = $[14];
        }
        let t10;
        if ($[15] !== t4 || $[16] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 1015" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[15] = t4;
          $[16] = t9;
          $[17] = t10;
        } else {
          t10 = $[17];
        }
        return t10;
      }
    case "light-green":
      {
        const t2 = `${id}-light-green`;
        let t3;
        if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="1015" fill="white" />;
          $[18] = t3;
        } else {
          t3 = $[18];
        }
        let t4;
        if ($[19] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[19] = t2;
          $[20] = t4;
        } else {
          t4 = $[20];
        }
        const t5 = `url(#${id}-light-green)`;
        let t6;
        if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="1015" fill="#9BD7D2" />;
          $[21] = t6;
        } else {
          t6 = $[21];
        }
        let t7;
        if ($[22] !== style) {
          t7 = <motion.path opacity={0.4} d="M542 1019H271V508.483C271 433.641 331.676 373 406.483 373C481.289 373 542 433.676 542 508.483V1019Z" fill="#85CDC7" style={style("bottom right")} />;
          $[22] = style;
          $[23] = t7;
        } else {
          t7 = $[23];
        }
        let t8;
        if ($[24] !== style) {
          t8 = <motion.path opacity={0.7} d="M5.64751e-05 -2.00002L271 -2L271 508.517C271 583.359 210.324 644 135.517 644C60.7107 644 3.5822e-05 583.324 4.23618e-05 508.517L5.64751e-05 -2.00002Z" fill="#85CDC7" style={style("top left")} />;
          $[24] = style;
          $[25] = t8;
        } else {
          t8 = $[25];
        }
        let t9;
        if ($[26] !== t5 || $[27] !== t7 || $[28] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[26] = t5;
          $[27] = t7;
          $[28] = t8;
          $[29] = t9;
        } else {
          t9 = $[29];
        }
        let t10;
        if ($[30] !== t4 || $[31] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 1015" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[30] = t4;
          $[31] = t9;
          $[32] = t10;
        } else {
          t10 = $[32];
        }
        return t10;
      }
    case "turquoise":
      {
        const t2 = `${id}-turquoise`;
        let t3;
        if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="1015" fill="white" />;
          $[33] = t3;
        } else {
          t3 = $[33];
        }
        let t4;
        if ($[34] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[34] = t2;
          $[35] = t4;
        } else {
          t4 = $[35];
        }
        const t5 = `url(#${id}-turquoise)`;
        let t6;
        if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="1015" fill="#00968C" />;
          $[36] = t6;
        } else {
          t6 = $[36];
        }
        let t7;
        if ($[37] !== style) {
          t7 = <motion.rect opacity={0.65} y="745" width="270" height="270" rx="16.4482" fill="#00A399" style={style("bottom left")} />;
          $[37] = style;
          $[38] = t7;
        } else {
          t7 = $[38];
        }
        let t8;
        if ($[39] !== style) {
          t8 = <motion.circle cx="405" cy="880" r="135" fill="#00A399" style={style("bottom right")} />;
          $[39] = style;
          $[40] = t8;
        } else {
          t8 = $[40];
        }
        let t9;
        if ($[41] !== style) {
          t9 = <motion.rect opacity={0.65} x="270" y="475" width="270" height="270" rx="16.4482" fill="#00A399" style={style("center right")} />;
          $[41] = style;
          $[42] = t9;
        } else {
          t9 = $[42];
        }
        let t10;
        if ($[43] !== style) {
          t10 = <motion.circle cx="135" cy="610" r="135" fill="#00A399" style={style("center left")} />;
          $[43] = style;
          $[44] = t10;
        } else {
          t10 = $[44];
        }
        let t11;
        if ($[45] !== t10 || $[46] !== t5 || $[47] !== t7 || $[48] !== t8 || $[49] !== t9) {
          t11 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}</g>;
          $[45] = t10;
          $[46] = t5;
          $[47] = t7;
          $[48] = t8;
          $[49] = t9;
          $[50] = t11;
        } else {
          t11 = $[50];
        }
        let t12;
        if ($[51] !== t11 || $[52] !== t4) {
          t12 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 1015" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t11}</svg>;
          $[51] = t11;
          $[52] = t4;
          $[53] = t12;
        } else {
          t12 = $[53];
        }
        return t12;
      }
    case "peach":
      {
        const t2 = `${id}-peach`;
        let t3;
        if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="1015" fill="white" />;
          $[54] = t3;
        } else {
          t3 = $[54];
        }
        let t4;
        if ($[55] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[55] = t2;
          $[56] = t4;
        } else {
          t4 = $[56];
        }
        const t5 = `url(#${id}-peach)`;
        let t6;
        if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="1015" fill="#FFB497" />;
          $[57] = t6;
        } else {
          t6 = $[57];
        }
        let t7;
        if ($[58] !== style) {
          t7 = <motion.path opacity={0.7} d="M219.206 1009.74H2.47161e-05V790.559C-0.0501942 696.21 76.4332 619.736 170.795 619.736H390V838.914C390 933.263 313.517 1009.74 219.155 1009.74" fill="#F8A98A" style={style("bottom left")} />;
          $[58] = style;
          $[59] = t7;
        } else {
          t7 = $[59];
        }
        let t8;
        if ($[60] !== style) {
          t8 = <motion.path opacity={0.7} d="M219.206 622H2.47161e-05V402.823C-0.0501942 308.474 76.4332 232 170.795 232H390V451.177C390 545.526 313.517 622 219.155 622" fill="#FFAF8F" style={style("center left")} />;
          $[60] = style;
          $[61] = t8;
        } else {
          t8 = $[61];
        }
        let t9;
        if ($[62] !== t5 || $[63] !== t7 || $[64] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[62] = t5;
          $[63] = t7;
          $[64] = t8;
          $[65] = t9;
        } else {
          t9 = $[65];
        }
        let t10;
        if ($[66] !== t4 || $[67] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 1015" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[66] = t4;
          $[67] = t9;
          $[68] = t10;
        } else {
          t10 = $[68];
        }
        return t10;
      }
    case "avocado":
      {
        const t2 = `${id}-avocado`;
        let t3;
        if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="1015" fill="white" />;
          $[69] = t3;
        } else {
          t3 = $[69];
        }
        let t4;
        if ($[70] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[70] = t2;
          $[71] = t4;
        } else {
          t4 = $[71];
        }
        const t5 = `url(#${id}-avocado)`;
        let t6;
        if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="1015" fill="#CCE88A" />;
          $[72] = t6;
        } else {
          t6 = $[72];
        }
        let t7;
        if ($[73] !== style) {
          t7 = <motion.path d="M490.5 503L131 862.5L490.5 1222L850 862.5L490.5 503Z" fill="#C2E079" style={style("bottom right")} />;
          $[73] = style;
          $[74] = t7;
        } else {
          t7 = $[74];
        }
        let t8;
        if ($[75] !== style) {
          t8 = <motion.path d="M99.5 888L-260 1247.5L99.5 1607L459 1247.5L99.5 888Z" fill="#C2E079" style={style("bottom left")} />;
          $[75] = style;
          $[76] = t8;
        } else {
          t8 = $[76];
        }
        let t9;
        if ($[77] !== style) {
          t9 = <motion.path d="M99.5 116L-260 475.5L99.5 835L459 475.5L99.5 116Z" fill="#C6E57D" style={style("top left")} />;
          $[77] = style;
          $[78] = t9;
        } else {
          t9 = $[78];
        }
        let t10;
        if ($[79] !== t5 || $[80] !== t7 || $[81] !== t8 || $[82] !== t9) {
          t10 = <g clipPath={t5}>{t6}{t7}{t8}{t9}</g>;
          $[79] = t5;
          $[80] = t7;
          $[81] = t8;
          $[82] = t9;
          $[83] = t10;
        } else {
          t10 = $[83];
        }
        let t11;
        if ($[84] !== t10 || $[85] !== t4) {
          t11 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 1015" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t10}</svg>;
          $[84] = t10;
          $[85] = t4;
          $[86] = t11;
        } else {
          t11 = $[86];
        }
        return t11;
      }
    case "sky-blue":
      {
        const t2 = `${id}-sky-blue`;
        let t3;
        if ($[87] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="1015" fill="white" />;
          $[87] = t3;
        } else {
          t3 = $[87];
        }
        let t4;
        if ($[88] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[88] = t2;
          $[89] = t4;
        } else {
          t4 = $[89];
        }
        const t5 = `url(#${id}-sky-blue)`;
        let t6;
        if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="1015" fill="#A6B9F1" />;
          $[90] = t6;
        } else {
          t6 = $[90];
        }
        let t7;
        if ($[91] !== style) {
          t7 = <motion.path d="M218.081 1009.74H2.45893e-05V791.683C-0.0499368 697.818 76.0413 621.736 169.919 621.736H388V839.79C388 933.655 311.909 1009.74 218.031 1009.74" fill="#90A7E7" style={style("bottom left")} />;
          $[91] = style;
          $[92] = t7;
        } else {
          t7 = $[92];
        }
        let t8;
        if ($[93] !== style) {
          t8 = <motion.path d="M218.081 622H2.45893e-05V403.947C-0.0499368 310.081 76.0413 234 169.919 234H388V452.053C388 545.919 311.909 622 218.031 622" fill="#9BB1EF" style={style("center left")} />;
          $[93] = style;
          $[94] = t8;
        } else {
          t8 = $[94];
        }
        let t9;
        if ($[95] !== t5 || $[96] !== t7 || $[97] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[95] = t5;
          $[96] = t7;
          $[97] = t8;
          $[98] = t9;
        } else {
          t9 = $[98];
        }
        let t10;
        if ($[99] !== t4 || $[100] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 1015" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[99] = t4;
          $[100] = t9;
          $[101] = t10;
        } else {
          t10 = $[101];
        }
        return t10;
      }
    case "orange":
      {
        const t2 = `${id}-orange`;
        let t3;
        if ($[102] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="1015" fill="white" />;
          $[102] = t3;
        } else {
          t3 = $[102];
        }
        let t4;
        if ($[103] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[103] = t2;
          $[104] = t4;
        } else {
          t4 = $[104];
        }
        const t5 = `url(#${id}-orange)`;
        let t6;
        if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="1015" fill="#F0B464" />;
          $[105] = t6;
        } else {
          t6 = $[105];
        }
        let t7;
        if ($[106] !== style) {
          t7 = <motion.path opacity={0.7} d="M487 1015H164L164 436.479C164 347.277 236.318 275 325.479 275C414.64 275 487 347.318 487 436.479L487 1015Z" fill="#EFAC53" style={style("bottom center")} />;
          $[106] = style;
          $[107] = t7;
        } else {
          t7 = $[107];
        }
        let t8;
        if ($[108] !== style) {
          t8 = <motion.path d="M2 -2.42484e-06L325 -3.05176e-05L325 161.521C325 250.723 252.682 323 163.521 323C74.36 323 2.00002 250.682 2.00002 161.521L2 -2.42484e-06Z" fill="#EFAC53" style={style("top center")} />;
          $[108] = style;
          $[109] = t8;
        } else {
          t8 = $[109];
        }
        let t9;
        if ($[110] !== t5 || $[111] !== t7 || $[112] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[110] = t5;
          $[111] = t7;
          $[112] = t8;
          $[113] = t9;
        } else {
          t9 = $[113];
        }
        let t10;
        if ($[114] !== t4 || $[115] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 1015" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[114] = t4;
          $[115] = t9;
          $[116] = t10;
        } else {
          t10 = $[116];
        }
        return t10;
      }
    case "sea":
      {
        const t2 = `${id}-sea`;
        let t3;
        if ($[117] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="1015" fill="white" />;
          $[117] = t3;
        } else {
          t3 = $[117];
        }
        let t4;
        if ($[118] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[118] = t2;
          $[119] = t4;
        } else {
          t4 = $[119];
        }
        const t5 = `url(#${id}-sea)`;
        let t6;
        if ($[120] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="1015" fill="#007190" />;
          $[120] = t6;
        } else {
          t6 = $[120];
        }
        let t7;
        if ($[121] !== style) {
          t7 = <motion.path opacity={0.4} d="M542 1019H271V508.483C271 433.641 331.676 373 406.483 373C481.289 373 542 433.676 542 508.483V1019Z" fill="#008AAA" style={style("bottom right")} />;
          $[121] = style;
          $[122] = t7;
        } else {
          t7 = $[122];
        }
        let t8;
        if ($[123] !== style) {
          t8 = <motion.path opacity={0.7} d="M5.64751e-05 -2.00002L271 -2L271 508.517C271 583.359 210.324 644 135.517 644C60.7107 644 3.5822e-05 583.324 4.23618e-05 508.517L5.64751e-05 -2.00002Z" fill="#008AAA" style={style("top left")} />;
          $[123] = style;
          $[124] = t8;
        } else {
          t8 = $[124];
        }
        let t9;
        if ($[125] !== t5 || $[126] !== t7 || $[127] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[125] = t5;
          $[126] = t7;
          $[127] = t8;
          $[128] = t9;
        } else {
          t9 = $[128];
        }
        let t10;
        if ($[129] !== t4 || $[130] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 1015" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[129] = t4;
          $[130] = t9;
          $[131] = t10;
        } else {
          t10 = $[131];
        }
        return t10;
      }
    case "mint":
      {
        const t2 = `${id}-mint`;
        let t3;
        if ($[132] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="1015" fill="white" />;
          $[132] = t3;
        } else {
          t3 = $[132];
        }
        let t4;
        if ($[133] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[133] = t2;
          $[134] = t4;
        } else {
          t4 = $[134];
        }
        const t5 = `url(#${id}-mint)`;
        let t6;
        if ($[135] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="1015" fill="#86CD9F" />;
          $[135] = t6;
        } else {
          t6 = $[135];
        }
        let t7;
        if ($[136] !== style) {
          t7 = <motion.path d="M219.206 1009.74H2.47161e-05V790.559C-0.0501942 696.21 76.4332 619.736 170.795 619.736H390V838.914C390 933.263 313.517 1009.74 219.155 1009.74" fill="#77C793" style={style("bottom left")} />;
          $[136] = style;
          $[137] = t7;
        } else {
          t7 = $[137];
        }
        let t8;
        if ($[138] !== style) {
          t8 = <motion.path d="M219.206 620H2.47161e-05V400.823C-0.0501942 306.474 76.4332 230 170.795 230H390V449.177C390 543.526 313.517 620 219.155 620" fill="#77C793" style={style("center left")} />;
          $[138] = style;
          $[139] = t8;
        } else {
          t8 = $[139];
        }
        let t9;
        if ($[140] !== t5 || $[141] !== t7 || $[142] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[140] = t5;
          $[141] = t7;
          $[142] = t8;
          $[143] = t9;
        } else {
          t9 = $[143];
        }
        let t10;
        if ($[144] !== t4 || $[145] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 1015" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[144] = t4;
          $[145] = t9;
          $[146] = t10;
        } else {
          t10 = $[146];
        }
        return t10;
      }
    case "yellow":
      {
        const t2 = `${id}-yellow`;
        let t3;
        if ($[147] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="1015" fill="white" />;
          $[147] = t3;
        } else {
          t3 = $[147];
        }
        let t4;
        if ($[148] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[148] = t2;
          $[149] = t4;
        } else {
          t4 = $[149];
        }
        const t5 = `url(#${id}-yellow)`;
        let t6;
        if ($[150] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="1015" fill="#FFD152" />;
          $[150] = t6;
        } else {
          t6 = $[150];
        }
        let t7;
        if ($[151] !== style) {
          t7 = <motion.path d="M490.5 503L131 862.5L490.5 1222L850 862.5L490.5 503Z" fill="#FFCC3D" style={style("bottom right")} />;
          $[151] = style;
          $[152] = t7;
        } else {
          t7 = $[152];
        }
        let t8;
        if ($[153] !== style) {
          t8 = <motion.path d="M99.5 116L-260 475.5L99.5 835L459 475.5L99.5 116Z" fill="#FFCC3D" style={style("top left")} />;
          $[153] = style;
          $[154] = t8;
        } else {
          t8 = $[154];
        }
        let t9;
        if ($[155] !== t5 || $[156] !== t7 || $[157] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[155] = t5;
          $[156] = t7;
          $[157] = t8;
          $[158] = t9;
        } else {
          t9 = $[158];
        }
        let t10;
        if ($[159] !== t4 || $[160] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 1015" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[159] = t4;
          $[160] = t9;
          $[161] = t10;
        } else {
          t10 = $[161];
        }
        return t10;
      }
    case "cobalt":
      {
        const t2 = `${id}-cobalt`;
        let t3;
        if ($[162] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="1015" fill="white" />;
          $[162] = t3;
        } else {
          t3 = $[162];
        }
        let t4;
        if ($[163] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[163] = t2;
          $[164] = t4;
        } else {
          t4 = $[164];
        }
        const t5 = `url(#${id}-cobalt)`;
        let t6;
        if ($[165] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="1015" fill="#2B52B8" />;
          $[165] = t6;
        } else {
          t6 = $[165];
        }
        let t7;
        if ($[166] !== style) {
          t7 = <motion.path opacity={0.7} d="M5.64751e-05 -2.00002L271 -2L271 508.517C271 583.359 210.324 644 135.517 644C60.7107 644 3.5822e-05 583.324 4.23618e-05 508.517L5.64751e-05 -2.00002Z" fill="#2F5FD6" style={style("top left")} />;
          $[166] = style;
          $[167] = t7;
        } else {
          t7 = $[167];
        }
        let t8;
        if ($[168] !== style) {
          t8 = <motion.path opacity={0.4} d="M542 1019H271V508.483C271 433.641 331.676 373 406.483 373C481.289 373 542 433.676 542 508.483V1019Z" fill="#2F5FD6" style={style("bottom right")} />;
          $[168] = style;
          $[169] = t8;
        } else {
          t8 = $[169];
        }
        let t9;
        if ($[170] !== t5 || $[171] !== t7 || $[172] !== t8) {
          t9 = <g clipPath={t5}>{t6}{t7}{t8}</g>;
          $[170] = t5;
          $[171] = t7;
          $[172] = t8;
          $[173] = t9;
        } else {
          t9 = $[173];
        }
        let t10;
        if ($[174] !== t4 || $[175] !== t9) {
          t10 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 1015" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t9}</svg>;
          $[174] = t4;
          $[175] = t9;
          $[176] = t10;
        } else {
          t10 = $[176];
        }
        return t10;
      }
    case "ocean":
      {
        const t2 = `${id}-ocean`;
        let t3;
        if ($[177] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="390" height="1015" fill="white" />;
          $[177] = t3;
        } else {
          t3 = $[177];
        }
        let t4;
        if ($[178] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[178] = t2;
          $[179] = t4;
        } else {
          t4 = $[179];
        }
        const t5 = `url(#${id}-ocean)`;
        let t6;
        if ($[180] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="390" height="1015" fill="#1A3C82" />;
          $[180] = t6;
        } else {
          t6 = $[180];
        }
        let t7;
        if ($[181] !== style) {
          t7 = <motion.rect opacity={0.65} y="745" width="270" height="270" rx="16.4482" fill="#3254A2" style={style("bottom left")} />;
          $[181] = style;
          $[182] = t7;
        } else {
          t7 = $[182];
        }
        let t8;
        if ($[183] !== style) {
          t8 = <motion.circle cx="405" cy="880" r="135" fill="#3254A2" style={style("bottom right")} />;
          $[183] = style;
          $[184] = t8;
        } else {
          t8 = $[184];
        }
        let t9;
        if ($[185] !== style) {
          t9 = <motion.rect opacity={0.65} x="270" y="475" width="270" height="270" rx="16.4482" fill="#3254A2" style={style("center right")} />;
          $[185] = style;
          $[186] = t9;
        } else {
          t9 = $[186];
        }
        let t10;
        if ($[187] !== style) {
          t10 = <motion.circle cx="135" cy="610" r="135" fill="#3254A2" style={style("center left")} />;
          $[187] = style;
          $[188] = t10;
        } else {
          t10 = $[188];
        }
        let t11;
        if ($[189] !== t10 || $[190] !== t5 || $[191] !== t7 || $[192] !== t8 || $[193] !== t9) {
          t11 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}</g>;
          $[189] = t10;
          $[190] = t5;
          $[191] = t7;
          $[192] = t8;
          $[193] = t9;
          $[194] = t11;
        } else {
          t11 = $[194];
        }
        let t12;
        if ($[195] !== t11 || $[196] !== t4) {
          t12 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 390 1015" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t11}</svg>;
          $[195] = t11;
          $[196] = t4;
          $[197] = t12;
        } else {
          t12 = $[197];
        }
        return t12;
      }
    default:
      {
        return null;
      }
  }
}
const RectangleLgMobileColorBlock = React.forwardRef<HTMLDivElement, VariantProps>((t0, ref) => {
  const $ = _c(26);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      color: t1,
      animated: t2,
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const color = t1 === undefined ? "bright-blue" : t1;
  const animated = t2 === undefined ? true : t2;
  const containerRef = useRef(null);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      target: containerRef,
      offset: ["start end", "end start"]
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    scrollYProgress
  } = useScroll(t3);
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [0, 1];
    t5 = [1, 1.3];
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  const shapeScale = useTransform(scrollYProgress, t4, t5);
  let t6;
  if ($[9] !== ref) {
    t6 = node => {
      (containerRef as React.MutableRefObject<HTMLDivElement | null>).current = node;
      if (typeof ref === "function") {
        ref(node);
      } else {
        if (ref) {
          ref.current = node;
        }
      }
    };
    $[9] = ref;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = !children && "aspect-[78/203]";
  let t8;
  if ($[11] !== className || $[12] !== t7) {
    t8 = cn("relative overflow-hidden", t7, className);
    $[11] = className;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== animated || $[15] !== color || $[16] !== shapeScale) {
    t9 = <RectangleLgMobileSvg color={color} animated={animated} shapeScale={shapeScale} />;
    $[14] = animated;
    $[15] = color;
    $[16] = shapeScale;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== children) {
    t10 = children && <div className="relative z-10">{children}</div>;
    $[18] = children;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== props || $[21] !== t10 || $[22] !== t6 || $[23] !== t8 || $[24] !== t9) {
    t11 = <div ref={t6} data-slot="color-block" className={t8} {...props}>{t9}{t10}</div>;
    $[20] = props;
    $[21] = t10;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
});
RectangleLgMobileColorBlock.displayName = "RectangleLgMobileColorBlock";
export { RectangleLgMobileColorBlock };